import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppShell from "../components/layout/AppShell";
import api from "../services/api";
import ProfileHeader from "../components/clients/profile/ProfileHeader";
import ProfileStats from "../components/clients/profile/ProfileStats";
import ConsortiumsSection from "../components/clients/profile/ConsortiumsSection";
import PoliciesSection from "../components/clients/profile/PoliciesSection";
import PaymentsSection from "../components/clients/profile/PaymentsSection";
import ReferralsSection from "../components/clients/profile/ReferralsSection";
import LoyaltySection from "../components/clients/profile/LoyaltySection";
import DocumentsSection from "../components/clients/profile/DocumentsSection";

export default function ClientProfilePage() {
  var params = useParams();
  var navigate = useNavigate();
  var clientId = params.id;

  var dataState = useState(null);
  var data = dataState[0];
  var setData = dataState[1];
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var errorState = useState(null);
  var error = errorState[0];
  var setError = errorState[1];

  var fetchProfile = useCallback(async function() {
    setLoading(true);
    setError(null);
    try {
      var res = await api.get("/clients/" + clientId);
      setData(res.data);
    } catch(err) {
      console.error(err);
      if (err.response && err.response.status === 404) {
        setError("Cliente nao encontrado");
      } else {
        setError("Erro ao carregar perfil");
      }
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(function() { fetchProfile(); }, [fetchProfile]);

  function handleAddConsortium() {
    navigate("/consorcios?add=true&client_id=" + clientId + "&client_name=" + encodeURIComponent(data.client.name));
  }

  function handleAddPolicy() {
    navigate("/seguros?add=true&client_id=" + clientId + "&client_name=" + encodeURIComponent(data.client.name));
  }

  return (
    <AppShell activePage="clientes" title="Ficha do Cliente">
      <div data-testid="client-profile-page">
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-8 h-8 border-3 border-[#3B82F6] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : error ? (
          <div className="text-center py-20">
            <p className="text-gray-500 font-medium">{error}</p>
            <button onClick={function() { navigate("/clientes"); }} className="mt-4 px-4 py-2 text-sm bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB]">Voltar</button>
          </div>
        ) : data ? (
          <div className="space-y-4">
            <ProfileHeader client={data.client} onAddConsortium={handleAddConsortium} onAddPolicy={handleAddPolicy} />
            <ProfileStats consortiums={data.consortiums} policies={data.policies} payments={data.payments} referrals={data.referrals} loyalty={data.loyalty} documentsCount={data.documents_count} />
            <LoyaltySection loyalty={data.loyalty} />
            <DocumentsSection clientId={clientId} consortiums={data.consortiums} policies={data.policies} />
            <ConsortiumsSection consortiums={data.consortiums} onRefresh={fetchProfile} />
            <PoliciesSection policies={data.policies} onRefresh={fetchProfile} />
            <PaymentsSection payments={data.payments} clientId={clientId} clientName={data.client.name} clientEmail={data.client.email} onRefresh={fetchProfile} />
            <ReferralsSection referrals={data.referrals} />
          </div>
        ) : null}
      </div>
    </AppShell>
  );
}
